import React from 'react';
import { useSelector } from 'react-redux';

import ContactForm from './ContactForm';
// import logo from '../../assets/images/Logo_Nefropolis.png';

//MUI
import { CircularProgress, Backdrop } from '@mui/material';

const Contact = () => {
    const { form1Loading } = useSelector(state => state.form);

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={form1Loading} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ContactForm />
        </>
    );
};

export default Contact;